import { postAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import { emptyArray } from "services/util/util.service";
import { BodyExtrasCall, BodyExtrasObj } from "./AveFlow.model";
import { getDiscountsLiterals, sessionLanguageMapping } from "./AveFlow.util";

// export function setBookingsExtrasCall(body: BodyExtrasCall, callback: Function, errorCallback: Function) {
//     postAxios(apiNames.BKING, false, '/bookings/addons', body)
//         .then((data: any) => {
//             callback(data);
//         })
//         .catch((error: any) => {
//             errorCallback(error)
//         })
// }
export async function setBookingsExtrasCall(array: Array<Array<BodyExtrasObj>>, callback: Function, errorCallback: Function) {
    await Promise.all(array.map((item: Array<BodyExtrasObj>) => setBookingsExtrasCallPromise({ tariffs: item }))) //CONCURRENTE
        .then((data: any) => {
            callback(data);
        })
        .catch((error: any) => {
            errorCallback(error)
        })
}
export function setBookingsExtrasCallPromise(body: BodyExtrasCall) {
    return postAxios(apiNames.BKING, false, '/bookings/addons', body)
}

function mapCardListWithResponse(data: any, trainList: any) {
    const withSeatOpction = trainList.filter((item: any) => !!item?.context);
    const otherTrain = trainList.filter((item: any) => !item?.context) || [];
    const seatingListWithMap = withSeatOpction?.map((item: any, index:number) => {
        const response = data[index];
        return {
            ...item,
            seatListOpction: item?.seatListOpction?.map((seatCard: any, i: number) => {
                return {
                    ...seatCard,
                    ...seatCard?.id === "SEAT" ? {
                        trainMapResponse: response?.data?.tariffs[0],
                    } : {}
                }
            })
        }
    })
    const seatList = !emptyArray(otherTrain) ? seatingListWithMap?.concat(otherTrain) : seatingListWithMap;
    const sortedArray = seatList?.sort((a: any, b: any) => a?.tripId - b?.tripId);
    return sortedArray;

}

export async function getSeatTrainMap(trainList: Array<Array<BodyExtrasObj>>, callback: Function, errorCallback: Function) {
    const array = trainList.flat(1);
    const bodyList = array.filter((item: BodyExtrasObj)=> !!item?.context);
    await Promise.all(bodyList.map((item: BodyExtrasObj) => {
        return getSeatTrainMapCallPromise({ tariffs: [{context: item?.context}]})
    })) //CONCURRENTE
        .then((data: any) => {
            const optionSeatList = mapCardListWithResponse(data, array);
            callback(optionSeatList);
        })
        .catch((error: any) => {
            errorCallback(error)
        })
}
export function getSeatTrainMapCallPromise(body: BodyExtrasCall) {
    return postAxios(apiNames.BKING, false, '/bookings/seats', body)
}

export function  getDepartureDate  (dateToMap: Date)  {
    const date = new Date(dateToMap);
    const dateWithFormat = date.toLocaleDateString(sessionLanguageMapping(), {
      weekday: "long",
      month: "long",
      day: "numeric",
    });
    return capitalizeFirstLetter(dateWithFormat);
  };

  const capitalizeFirstLetter = (item: string) => {
    return item ? item.charAt(0).toUpperCase() + item.slice(1) : "";
  };


  export function  mappingLiteralDiscounts (id: string,t:any)  {
    let discountsLiterals = getDiscountsLiterals(t) as any;
    const value = discountsLiterals?.discountCardsList?.find((item: any) => item.id === id)?.title;
    return value;
  }